<template>
    <div class="flex flex-col p-1 md:p-2">
        <p class="text-md font-semibold mb-4 text-center">Sorry to know that. Please tell us why you are cancelling this order?</p>
        <p v-if="error" class="text-sm text-danger-700 m-1 text-center ">Please select cancel reason.</p>
        <div class="border-2 border-gray-200 p-4">
            <ul>
                <li v-for="(item, index) in cancelReasons" class="leading-8 text-sm" :key="index">
                    <label>
                        <input
                            type="radio"
                            :name="'reasonGroup'"
                            :checked="selected === item.code"
                            @change="selectReason(item.code)"
                            class="form-radio text-primary focus:ring-transparent"
                        />
                        {{ item.reason }}
                    </label>
                </li>
            </ul>
        </div>
        <div class="flex justify-around mt-4">
            <UButton size="md" label="Cancel order" variant="outline" class="md:w-2/5 w-5/12 text-nowrap" @click="CancelOrder()" :loading="isLoading" />
            <UButton size="md" label="No, Don't Cancel" class="md:w-2/5 w-5/12" @click="emit('close')" />
        </div>
    </div>
</template>

<script setup>
const selected = ref(null);
const props = defineProps(['data']);
const emit = defineEmits(['close','success']);
const cancelListener = ref(null);
const isLoading = ref(false);
const listenerTimeout = 10000;
const { isMobile } = useDevice();
const slideover = useSlideover();
import { V3ModalComponent } from '#components';
import { V3PopupComponent } from '#components';
const error = ref(false);
const result = ref(null);


const cancelReasons = [
    { code: '001', reason: 'Price of one or more items have changed due to which buyer was asked to make additional payment' },
    { code: '003', reason: 'Product available at lower than order price' },
    { code: '006', reason: 'Order / fulfillment not received as per buyer app SLA' },
    { code: '009', reason: 'Wrong product delivered' },
    { code: '010', reason: 'Buyer wants to modify details' }
];

const selectReason = (code) => {
    selected.value = selected.value === code ? null : code;
};

const CancelOrder = async () => {
    const type = 'full'
    if(selected.value === null){
        error.value = true;
        return;
    }
  try {
    error.value = false;
    isLoading.value = true;
    const response = await useAPIHandler('post', `/orders/${props.data.order_id}/cancel`, { 
      body: { 
        type: 'full', 
        code: selected.value  
      },
      auth: true 
    });
    const messageId = response.data.message_id;
    
    cancelListener.value = setInterval(async () => { 
      await responseListener(messageId, type === 'full' ? 'on_cancel' : 'on_update'); 
    }, 2000);
    
    setTimeout(function () {
        stopCancelListener();
    }, listenerTimeout);

  } catch (err) {
    isLoading.value = false;
    console.log("err", err);
    handleError()
  } 
};

const handleError = () =>{
    emit('close');
    const message = 'Cancellation is not available now. Please try later';
    const component = isMobile ? V3PopupComponent : V3ModalComponent;
    slideover.open(component, {
      component: 'error',
      data: { message },
      onClose: slideover.close
    });

}

const stopCancelListener = () => {
  isLoading.value = false
  if(result.value === null){
    handleError();
  }
  clearInterval(cancelListener.value);
};

const responseListener = async (messageId, action) => {
  try {
    const apiResult = await useAPIHandler('get', `/transactions?message_id=${messageId}&action=${action}`, { 
      auth: true 
    }); 
    const { data } = apiResult;
    result.value = apiResult?.data;
    if (data) {
      isLoading.value = false; 
      emit('success');
    }
  } catch (err) {
    isLoading.value = false; 
    console.error('Error in responseListener:', err);
    handleError();
  }
};

</script>
